'use client';

import { useInView } from 'motion/react';
import { ImageProps } from 'next/image';
import { useRef } from 'react';
import VimeoPlayer from 'react-player/vimeo';

import './style.css';
import { VimeoPlayerPreview } from './VimeoPlayerPreview';

interface VimeoVideoProps {
  url?: string;
  loop?: boolean;
  muted?: boolean;
  resolvedImage?: ImageProps;
}

export const VimeoVideo = ({ loop, muted, resolvedImage, url }: VimeoVideoProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '100px 0px 0px 0px' });

  return (
    <div ref={ref} className="relative w-full">
      {isInView ? (
        <div className="react-player relative">
          <VimeoPlayer
            url={url}
            width="100%"
            height="100%"
            controls
            loop={loop}
            muted={muted}
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </div>
      ) : (
        <VimeoPlayerPreview resolvedImage={resolvedImage} />
      )}
    </div>
  );
};
